import { useEffect, useState } from "react";

/**
 * Connectivity, for `<OfflineBanner>`. Assumes online when the browser cannot say — a
 * false offline banner on a working connection is its own kind of failure.
 */
export function useOnline(): boolean {
  const [online, setOnline] = useState<boolean>(
    () => globalThis.navigator?.onLine ?? true,
  );

  useEffect(() => {
    const up = (): void => setOnline(true);
    const down = (): void => setOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    return () => {
      window.removeEventListener("online", up);
      window.removeEventListener("offline", down);
    };
  }, []);

  return online;
}
